module.exports = __webpack_public_path__ + "img/resources-1440.2ece13bf.jpg";